import { Component, OnInit, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import {
  JobService
} from "../../shared/service/job.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ApplicationConfig } from "src/app/config/application.config";
import { BaseComponent } from "../../shared/components/base.component";
import { noop } from "rxjs";
import { DeclineModalComponent } from "../../shared/components/decline-modal/decline-modal.component";
import { FormGroup, FormControl } from "@angular/forms";
import { ChappsImageCropperComponent, MultimediaViewerService } from "@npm.chapps.com/chapps.common.angular.library";
import { ExecuteModalComponent } from "../../shared/components/execute-modal/execute-modal.component";
import { TranslateService } from "@ngx-translate/core";
import { Localization } from "../../shared/enums/localization";
import { ActionDetail } from "../../shared/model/actionDetail";
import { IssueDetail } from "../../shared/model/issueDetail";
import { ActionStatusType, StructureContactType } from "../../shared/enums/enums";
import { Multimedium } from "@npm.chapps.com/chapps.common.angular.library/lib/components/multimedium/model/multimedium";
import { AcceptModalComponent } from "../accept-modal/accept-modal.component";
import { LocalStorageService } from "../../shared/service/local-storage.service";

@Component({
  selector: "app-job",
  templateUrl: "./job.component.html",
  styleUrls: ["./job.component.scss"]
})
export class JobComponent extends BaseComponent implements OnInit {
  @ViewChild(AcceptModalComponent)
  acceptModal: AcceptModalComponent;

  @ViewChild(DeclineModalComponent)
  declineModal: DeclineModalComponent;

  @ViewChild(ExecuteModalComponent)
  executeModal: ExecuteModalComponent;

  public id: string;
  public details: ActionDetail;
  public areDetailsLoading: boolean;
  public formGroup: FormGroup;
  public readonly: boolean;
  public showLess: boolean;

  @ViewChild(ChappsImageCropperComponent)
  chappsImageCropperComponent: ChappsImageCropperComponent;

  public get feedbackFC() {
    return this.formGroup.get("feedback");
  }

  constructor(
    private jobService: JobService,
    private route: ActivatedRoute,
    private multimediaViewerService: MultimediaViewerService,
    public applicationConfig: ApplicationConfig,
    private location: Location,
    private translateService: TranslateService,
    private localStorage: LocalStorageService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.details = {} as ActionDetail;
    this.route.params.subscribe(params => {
      this.id = params["jobId"];
      this.loadDetails();
      this.initForm();
      this.resetForm();
    });
    this.route.parent.url.subscribe(url => {
      if (url.map(segment => segment.path).includes("log")) {
        this.readonly = true;
      }
    });
  }

  private initForm() {
    this.formGroup = new FormGroup({
      feedback: new FormControl(null)
    });
  }

  private resetForm() {
    this.formGroup.setValue({
      feedback: null
    });
  }

  public onBackButtonClick() {
    this.location.back();
  }

  public loadDetails() {
    this.areDetailsLoading = true;
    this.jobService.getJobDetails(this.id).subscribe(
      (response) => {
        (this.details = response);
      },
      noop,
      () => (this.areDetailsLoading = false)
    );
  }

  public getStatusLabel(): string {
    return this.details.status == ActionStatusType.SENT ?
      this.translateService.instant(Localization.Requested) :
      this.translateService.instant(`actionStatusType_${this.details.status}`);
  }

  public canAccept(): boolean {
    return this.details.status == ActionStatusType.SENT;
  }

  public canExecute(): boolean {
    return this.details.status == ActionStatusType.ACCEPTED;
  }

  public canDecline(): boolean {
    return this.details.status == ActionStatusType.SENT || this.details.status == ActionStatusType.ACCEPTED || this.details.status == ActionStatusType.EXECUTING;
  }

  public execute() {
    this.executeModal.show();
  }

  public decline() {
    this.declineModal.show();
  }

  public accept() {
    this.acceptModal.show();
  }

  public onAccepted() {
    this.loadDetails();
  }

  public isScheduled(): boolean {
    let today = new Date();
    today.setHours(24,0,0,0);
    return this.details.scheduledOn && (new Date(this.details.scheduledOn) > today);
  }

  public onCompleted() {
    this.router.navigate(this.readonly ? ["log"] : ["jobs"]);
  }

  public getIssueLocation(issue: IssueDetail): string {
    return (issue.elementStructureLabel ? issue.elementStructureLabel + ' / ' : '') + (issue.locationPath || issue.buildingLabel || '')
  }

  public isMediaEmpty(issue: IssueDetail): boolean {
    return issue.multimedia == null || issue.multimedia.length === 0;
  }

  public openMediaInMultimediaViewer(multimedia: Multimedium[], index: number) {
    this.multimediaViewerService.show(multimedia, index);
  }

  public toggleImagesHide() {
    this.showLess = !this.showLess;
  }

  public getCulture(): string {
    return this.localStorage.getCulture();
  }
}
